import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../LoadingComponent/LoadingComponent';
import isEmpty from 'lodash/isEmpty';
import { getGeoDataByType, GeoTypes } from '../../../../constants/geodata';
import { bindActionCreators } from 'redux';
import { setLoading } from '../../../../actions';
import ChangeAddressForm from '../../../tools/common/ChangeAddressForm/ChangeAddressForm';
import { setNewAddress } from '../../../../actions/tools/ToolActions';
import * as toolSelectors from '../../../../selectors/tools';
import DecisionTreeInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import { extractSelectedTicketFromState, getDecisionNodeAtPath } from '../../../../extractFromState';
import { connect } from 'react-redux';
import { NextButton, BackButton } from '../../../common/buttonsComponents';
import { returnToPreviousMacroWizardPath, addEdgeToDecisionTreePath } from '../../../../actions/searchActions';
import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import transform from 'lodash/transform';
import isObject from 'lodash/isObject';
import * as errorUtils from '../../../../util/error';
import get from 'lodash/get';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';
import { selectSubscriptionTask } from '../../../../actions/tools/CommonSubscriptionActions';
import {
  Container,
  ContentWrapper,
  TitleText,
  PageHeader,
  Icon,
  AddressWrapper,
  ErrorMessageWrapper,
  ButtonWrapper,
  PrimaryButton,
} from './DTChangeAddressForOrderOrSubscriptionNode.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

export class DTChangeAddressForOrderOrSubscriptionNode extends Component {
  static propTypes = {
    address: PropTypes.object.isRequired,
    selectedSubscription: PropTypes.object.isRequired,
    fetchAddress: PropTypes.func,
    selectedShopContext: PropTypes.string,
  };

  static defaultProps = {
    address: {},
    fetchAddress: () => Promise.resolve(),
    updateAddress: () => Promise.resolve(),
  };

  formFields = [
    {
      field: 'first_name',
      label: 'First name',
      type: 'input',
    },
    {
      field: 'last_name',
      label: 'Last name',
      type: 'input',
    },
    {
      field: 'company',
      label: 'Company',
      type: 'input',
    },
    {
      field: 'country',
      label: 'Country',
      type: 'select',
      items: getGeoDataByType(GeoTypes.COUNTRY_LIST).map((item) => ({ value: item.name, label: item.name })),
      cleanBefore: ['province', 'province_code'],
    },
    {
      field: 'city',
      label: 'City',
      type: 'input',
    },
    {
      field: 'province',
      label: 'State/Region',
      type: 'select',
      items: getGeoDataByType(GeoTypes.PROVINCE_LIST).map((item) => ({ value: item.name, label: item.name })),
      show: { country: 'United States' },
    },
    {
      field: 'province',
      label: 'Province',
      type: 'input',
      hide: { country: 'United States' },
    },
    {
      field: 'address1',
      label: 'Address line 1',
      type: 'input',
    },
    {
      field: 'address2',
      label: 'Address line 2',
      type: 'input',
    },
    {
      field: 'zip',
      label: 'ZIP',
      type: 'input',
    },
    {
      field: 'cart_note',
      label: 'Cart note',
      type: 'input',
    },
  ];

  state = {
    protectAddress: {},
    errorMessages: {},
    isRequestingFetch: false,
    isRequestingUpdate: false,
    apiErrorMessage: '',
  };

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    this.fetchAddress();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  requestWrapper = async ({ request, success = () => {}, error = () => {}, processingState }) => {
    this.setState({ apiErrorMessage: '' });
    if (typeof processingState === 'string') {
      this.setState({ [processingState]: true });
    }

    try {
      success(await request());
    } catch (err) {
      error(err);
    }

    if (typeof processingState === 'string' && this._isMounted) {
      this.setState({ [processingState]: false });
    }
  };

  fetchAddress = async () => {
    const params = {
      shopName: this.props.selectedShopContext,
      subscriptionId: this.props.selectedSubscription.id,
    };

    return this.requestWrapper({
      request: () => this.props.fetchAddress(params),
      success: (address) => {
        this.props.setNewAddress(address);
        if (this._isMounted) {
          this.setState({ protectAddress: address });
        }
      },
      processingState: 'isRequestingFetch',
    });
  };

  validate = (value) => {
    const errorMessages = {};
    if (!value.last_name) {
      errorMessages.last_name = 'Last Name is required';
    }

    if (!value.address1) {
      errorMessages.address1 = 'Address line 1 is required';
    }

    if (!value.city) {
      errorMessages.city = 'City is required';
    }

    if (!value.country) {
      errorMessages.country = 'Country is required';
    }

    if (!value.province) {
      errorMessages.province = 'Province / State is required';
    }

    if (!value.zip) {
      errorMessages.zip = 'Zip is required';
    }

    this.setState({ errorMessages });

    return Object.keys(errorMessages).length === 0;
  };

  update = (data) => {
    this.props.setNewAddress(data);
    const errorMessages = { ...this.state.errorMessages };
    Object.keys(data).forEach((key) => delete errorMessages[key]);
    this.setState({ errorMessages });
  };

  difference(object, base) {
    return transform(object, (result, value, key) => {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? difference(value, base[key]) : value;
      }
    });
  }

  errorHandler = (error) => {
    let responseErrors = {};
    try {
      this.props.setLoading(false, 'CopyTextContainer');
      const message = get(error, 'response.body.message', '{}');
      const { zipcode: zip, address1, state: province, city } = JSON.parse(message);
      responseErrors = { zip, address1, province, city };
    } catch (_) {}

    const errors = {
      ...errorUtils.getApiValidationErrorMessage(error),
      ...responseErrors,
    };

    const errorMessages = Object.keys(errors)
      .filter((errorKey) => typeof errors[errorKey] === 'string')
      .reduce((acc, errorKey) => {
        // eslint-disable-next-line
        let error = errors[errorKey];
        const pattern = new RegExp(' zip ', 'ig');
        if (pattern.test(error)) {
          error = error.replace(pattern, ' ZIP ');
        }

        if (error[error.length - 1] !== '.') {
          error = `${error}.`;
        }

        acc[errorKey] = error;

        return acc;
      }, {});

    if (isEmpty(errorMessages)) {
      return this.setState({ apiErrorMessage: 'Something went wrong! Request failed.' });
    }

    this.setState({ errorMessages });
  };

  getUpdateAddressPayload = () => ({
    shopName: this.props.selectedShopContext,
    subscriptionId: this.props.selectedSubscription.id,
    updateType: 'subscription',
    conversationId: this.props.selectedTicket.ticketId,
    simplrAccountId: this.props.selectedTicket.simplrAccountPtrId,
    address: this.formFields.reduce(
      (address, option) => ({
        ...address,
        [option.field]: this.props.address[option.field],
      }),
      {}
    ),
  });

  updateAddress = async () => {
    this.props.setLoading(true, 'CopyTextContainer');
    if (!this.validate(this.props.address)) {
      return null;
    }
    // eslint-disable-next-line
    const difference = this.difference(this.props.address, this.state.protectAddress);
    if (!Object.keys(difference).length) {
      showErrorPopup(`You have entered the current address`, 'Oops!');

      return this.props.setLoading(false, 'CopyTextContainer');
    }

    const params = this.getUpdateAddressPayload();

    return this.requestWrapper({
      request: () => this.props.updateAddress(params),
      error: this.errorHandler,
      success: async () => {
        if (this._isMounted) {
          this.setState({ protectAddress: this.state.address });
        }
        this.props.setLoading(false, 'CopyTextContainer');
        this.props.addEdgeToDecisionTreePath('address_changed');
      },
      processingState: 'isRequestingUpdate',
    });
  };

  renderError() {
    if (this.state.apiErrorMessage) {
      return <ErrorMessageWrapper error={this.state.apiErrorMessage}>{this.state.apiErrorMessage}</ErrorMessageWrapper>;
    }

    return null;
  }

  renderTryAgain() {
    return (
      <Container>
        {this.renderHeader()}
        <ContentWrapper>
          <AddressWrapper>
            <ErrorMessageWrapper>Failed get address</ErrorMessageWrapper>
            <ButtonWrapper>
              <PrimaryButton onClick={this.fetchAddress}>Try again</PrimaryButton>
            </ButtonWrapper>
          </AddressWrapper>
        </ContentWrapper>
      </Container>
    );
  }

  renderButtons() {
    return (
      <ActionsButtonsWrapper>
        <NextButton
          id="copyTextNextButton"
          disabled={this.state.isRequestingUpdate}
          active={!this.state.isRequestingUpdate}
          onClick={this.updateAddress}
        >
          CHANGE ADDRESS
        </NextButton>
        <BackButton onClick={() => this.props.returnToPreviousMacroWizardPath()}>BACK</BackButton>
      </ActionsButtonsWrapper>
    );
  }

  renderHeader() {
    const { decisionNode } = this.props;

    return (
      <PageHeader>
        <Icon src="/images/attention_icon.svg" alt="back-button" />
        <TitleText>{decisionNode.title}</TitleText>
      </PageHeader>
    );
  }

  renderLoading() {
    return (
      <Container>
        {this.renderHeader()}
        <ContentWrapper position={'absolute'}>
          <Loading delay={50} label={'Loading...'} />
        </ContentWrapper>
      </Container>
    );
  }

  render() {
    if (this.state.isRequestingFetch) {
      return this.renderLoading();
    }

    if (isEmpty(this.props.address)) {
      return this.renderTryAgain();
    }

    return (
      <>
        <Container>
          {this.renderHeader()}
          <ContentWrapper>
            <DecisionTreeInfoWidget />
            {this.renderError()}
            <ChangeAddressForm
              errors={this.state.errorMessages}
              readOnly={false}
              formFields={this.formFields}
              update={this.update}
              data={this.props.address}
            />
          </ContentWrapper>
        </Container>
        {this.renderButtons()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  address: toolSelectors.getAddress(state),
  selectedShopContext: toolSelectors.selectShopContext(state),
  selectedTicket: extractSelectedTicketFromState(state),
  selectedSubscription: toolSelectors.getFirstSelectedSubscription(state),
  decisionNode: getDecisionNodeAtPath(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectSubscriptionTask: selectSubscriptionTask,
      setNewAddress,
      returnToPreviousMacroWizardPath,
      addEdgeToDecisionTreePath,
      setLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DTChangeAddressForOrderOrSubscriptionNode);
